/**
 * The one client-side e-mail check: intentionally permissive, a single @ with a dotted domain.
 * The server's validator does the authoritative check; this only catches obvious typos before a
 * round-trip.
 *
 * The domain is matched as dot-separated labels whose character class EXCLUDES the dot, so the
 * separator `\.` never overlaps the quantified label class. That keeps the regex linear-time and
 * free of the catastrophic backtracking the naive `[^\s@]+\.[^\s@]+` form is prone to
 * (Sonar S5852 / ReDoS).
 */
export const EMAIL_RE = /^[^\s@]+@[^\s.@]+(?:\.[^\s.@]+)+$/;
